import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import AIEmailModal from './AIEmailModal';
import './AIEmailAssistant.scss';

function AIEmailButton({ subject, activities, profile, onSaveActivity, inline }) {
  const [t] = useTranslation('AI_EMAIL_ASSISTANT');
  const [open, setOpen] = useState(false);
  const wrapperClassName = inline
    ? 'ai-email-button-wrapper ai-email-button-wrapper--inline'
    : 'col-12 col-md-3 ai-email-button-wrapper';

  return (
    <div className={wrapperClassName}>
      <Button className="ai-email-button" onClick={() => setOpen(true)}>
        <span>✨</span> {t('AI_EMAIL')}
      </Button>
      <AIEmailModal
        open={open}
        toggle={() => setOpen(!open)}
        subject={subject}
        activities={activities}
        profile={profile}
        onSaveActivity={onSaveActivity}
      />
    </div>
  );
}

AIEmailButton.propTypes = {
  subject: PropTypes.shape({}).isRequired,
  activities: PropTypes.arrayOf(PropTypes.shape({})),
  profile: PropTypes.shape({}),
  onSaveActivity: PropTypes.func,
  inline: PropTypes.bool,
};

AIEmailButton.defaultProps = {
  activities: [],
  profile: {},
  onSaveActivity: undefined,
  inline: false,
};

export default AIEmailButton;
